<template>
    <b-modal :id="id" size="xl">
        <div v-if="variant">
            <b-row>
                <b-col>
                    T04:
                </b-col>
                <b-col>
                    {{ variant.variationId }}
                </b-col>
            </b-row>
        </div>
        <div v-if="article">
            <b-row>
                <b-col>
                    T01:
                </b-col>
                <b-col>
                    {{ article.id }}
                </b-col>
            </b-row>
        </div>
        <div v-if="category">
            <b-row>
                <b-col>
                    T40:
                </b-col>
                <b-col>
                    {{ category.customerId }}
                </b-col>
            </b-row>
        </div>
        <div v-if="user">
            <b-row>
                <b-col>
                    T40_ID_LOGIN_DIAMOND:
                </b-col>
                <b-col>
                    <span
                        v-if="user.externalData.company.externalAccountType == 'DIAMOND'">{{ user.externalData.company.id }}</span>
                    <span v-else>NULL</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    T40_ID_LOGIN_DL:
                </b-col>
                <b-col>
                    <span
                        v-if="user.externalData.company.externalAccountType == 'DIAMOND_LIGHT'">{{ user.externalData.company.id }}</span>
                    <span v-else>NULL</span>
                </b-col>
            </b-row>

        </div>
        <div class="mt-2" v-if="variant && user && category && article">
            <b>Preisabfrage</b>
            <p>
                EXEC [dbo].[USP_WEBSHOP_ARTIKELPREIS]
                @T04_ID = {{ variant.variationId }},
                @T40_ID = {{ category.customerId }},
                @T40_ID_LOGIN_DIAMOND = <span
                v-if="user.externalData.company.externalAccountType == 'DIAMOND'">{{ user.externalData.company.id }}</span>
                <span v-else>NULL</span>,
                @T40_ID_LOGIN_DL = <span
                v-if="user.externalData.company.externalAccountType == 'DIAMOND_LIGHT'">{{ user.externalData.company.id }}</span>
                <span v-else>NULL</span>;
            </p>
        </div>
       <div v-if="variant && variant.articlePrice">
          <b>Preise</b>
          <table class="table table-striped">
             <thead>
                <tr>
                   <td></td>
                   <td>Preis</td>
                   <td>Musterpreis</td>
                </tr>
             </thead>

             <tr>
                <td>
                   Asia
                </td>
                <td>
                   {{variant.articlePrice.priceAsia}}
                </td>
                <td>
                   {{variant.articlePrice.samplePriceAsia}}
                </td>
             </tr>

             <tr>
                <td>
                   Europe
                </td>
                <td>
                   {{variant.articlePrice.priceEurope}}
                </td>
                <td>
                   {{variant.articlePrice.samplePriceEurope}}
                </td>
             </tr>

             <tr>
                <td>
                   Istanbul
                </td>
                <td>
                   {{variant.articlePrice.priceIstanbul}}
                </td>
                <td>
                   {{variant.articlePrice.samplePriceIstanbul}}
                </td>
             </tr>
          </table>
       </div>
        <div class="mt-2" v-if="variant && variant.gtlArticle">
            <b>GTL Attribute</b><br>
            <div v-if="gtlAttributes.length > 0">
                <div :key="key" v-for="(item,key) in gtlAttributes">
                    <article-debug-tree-node :node="item"/>
                </div>
            </div>
            <div v-else>
                Keine GTL Attribute zugeordnet.
            </div>
        </div>
    </b-modal>
</template>
<script>
import {mapState} from "vuex";
import ArticleDebugTreeNode from "@client/src/viewsShop/components/ArticleDebugTreeNode";

export default {
    name: 'debug-modal',
    components: {ArticleDebugTreeNode},
    props: {
        id: String,
        article: Object,
        variant: Object,
        category: Object
    },
    methods: {
        collectChildNodes(node, childNodes) {
            if(node.childNodes.length > 0) {
                childNodes.push(...node.childNodes);
                node.childNodes.forEach(childNode => {
                    this.collectChildNodes(childNode, childNodes)
                })
            }
        }
    },
    computed: {
        ...mapState("account", ['user']),
        gtlAttributes() {
            let res = [];
            if(this.variant && this.variant.gtlArticle) {
                let attributes = this.$_.cloneDeep(this.variant.gtlArticle.structuredAttributes);
                attributes.forEach(node => {
                    let childNodes = [];
                    this.collectChildNodes(node, childNodes);
                    node.childNodes = childNodes;
                    res.push(node);
                })
            }
            return res;
        },
    }
}
</script>